import actions from './actions';

const initState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_BRAND:
    case actions.CREATE_STORE: {
      return {
        ...state,
        isCreating: true,
      };
    }
    case actions.CREATE_BRAND_ENDED:
    case actions.CREATE_STORE_ENDED: {
      return {
        ...state,
        isCreating: false,
      };
    }
    case actions.SEARCH_BRANDS:
    case actions.SEARCH_STORES:
    case actions.FIND_STORE:
    case actions.FIND_BRAND: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case actions.SEARCH_BRANDS_ENDED:
    case actions.SEARCH_STORES_ENDED:
    case actions.FIND_STORE_ENDED:
    case actions.FIND_BRAND_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    case actions.UPDATE_BRAND:
    case actions.UPDATE_STORE: {
      return {
        ...state,
        isUpdating: true,
      };
    }
    case actions.UPDATE_BRAND_ENDED:
    case actions.UPDATE_STORE_ENDED: {
      return {
        ...state,
        isUpdating: false,
      };
    }
    case actions.DELETE_BRANDS:
    case actions.DELETE_STORES: {
      return {
        ...state,
        isDeleting: true,
      };
    }
    case actions.DELETE_BRANDS_ENDED:
    case actions.DELETE_STORES_ENDED: {
      return {
        ...state,
        isDeleting: false,
      };
    }
    case actions.CREATE_BRAND_BATCH: {
      return {
        ...state,
        isCreating: true,
      };
    }
    case actions.CREATE_BRAND_BATCH_ENDED: {
      return {
        ...state,
        isCreating: false,
      };
    }
    case actions.CREATE_STORE_BATCH: {
      return {
        ...state,
        isCreating: true,
      };
    }
    case actions.CREATE_STORE_BATCH_ENDED: {
      return {
        ...state,
        isCreating: false,
      };
    }
    default:
      return state;
  }
}
